import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import site from "./site";

export default mergeFragments([base, site]);
